import type { SetStateAction } from 'react';
import { create } from 'zustand';

type CommandPaletteState = {
    hasOpened: boolean;
    open: boolean;
    setOpen: (nextOpen: SetStateAction<boolean>) => void;
};

export const useCommandPaletteStore = create<CommandPaletteState>((set) => ({
    hasOpened: false,
    open: false,
    setOpen: (nextOpen) =>
        set((state) => {
            const open = typeof nextOpen === 'function' ? nextOpen(state.open) : nextOpen;

            return {
                hasOpened: state.hasOpened || open,
                open,
            };
        }),
}));
